document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById('bundle-upgrade-container');
  if (!container) return;

  const triggers = document.querySelectorAll('.bundle-trigger-btn');
  const modal = document.getElementById('bundle-modal');
  const closeModalBtn = document.getElementById('bundle-modal-close');
  const backdrop = document.querySelector('.bundle-modal-backdrop');
  const stepIndicator = document.getElementById('bundle-step-indicator');
  const stepsWrapper = document.querySelector('.bundle-steps-wrapper');
  const btnNext = document.getElementById('bundle-cta-next');
  const btnAdd = document.getElementById('bundle-cta-add');
  const errorMessage = document.getElementById('bundle-error-message');

  const variants = window.productVariants || [];
  let totalSteps = 2;
  let selectedVariants = [];

  function init() {
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const target = trigger.getAttribute('data-bundle-target');
        if (target) totalSteps = parseInt(target, 10);

        const cardTitle = trigger.querySelector('.grynd-bundle-title');
        const priceMatch = cardTitle ? cardTitle.textContent.match(/\$[\d,]+\.?\d*/) : null;
        window._bundlePrice = priceMatch ? priceMatch[0] : null;

        const cardSub = trigger.querySelector('.grynd-bundle-sub');
        window._bundleFreeShipping = cardSub
          ? cardSub.textContent.includes('FREE Shipping') || cardSub.textContent.includes('free shipping')
          : false;

        openModal();
      });
    });

    if (closeModalBtn) closeModalBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);

    if (!window._gryndKeyHandler) {
      window._gryndKeyHandler = function (e) {
        if (e.key === 'Escape') {
          const m = document.getElementById('bundle-modal');
          if (m && !m.classList.contains('hidden')) closeModal();
        }
      };
      document.addEventListener('keydown', window._gryndKeyHandler);
    }

    if (btnNext) btnNext.style.display = 'none';
    if (btnAdd) btnAdd.addEventListener('click', handleAddToCart);
  }

  function openModal() {
    if (!modal) return;
    buildDOM();
    modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('bundle-open');

    // Header title
    if (stepIndicator) {
      if (totalSteps === 2) {
        stepIndicator.textContent = '2-Pair Pro Bundle';
      } else if (totalSteps === 5) {
        stepIndicator.textContent = '5-Pair Rotation';
      } else {
        stepIndicator.textContent = totalSteps + '-Pair Bundle';
      }

      // Per-pair price in header
      const existingPrice = modal.querySelector('.bundle-header-price');
      if (existingPrice) existingPrice.remove();
      if (window._bundlePrice) {
        const perPair = '$' + (parseFloat(window._bundlePrice.replace(/[$,]/g, '')) / totalSteps).toFixed(0) + '/pair';
        const priceEl = document.createElement('span');
        priceEl.className = 'bundle-header-price';
        priceEl.textContent = perPair;
        stepIndicator.after(priceEl);
      }

      // Caption below header
      const existingCaption = modal.querySelector('.bundle-header-caption');
      if (existingCaption) existingCaption.remove();
      const captionMap = { 2: 'Mix any 2 colourways · Save $65', 5: 'Mon–Fri training rotation · Save $60', 3: 'Save $30 off RRP' };
      const captionText = captionMap[totalSteps] || null;
      if (captionText) {
        const caption = document.createElement('div');
        caption.className = 'bundle-header-caption';
        caption.textContent = captionText;
        stepIndicator.closest('.bundle-modal-header').after(caption);
      }
    }

    // CTA button text
    if (btnAdd) {
      const price = window._bundlePrice || '';
      const shipping = window._bundleFreeShipping;
      btnAdd.textContent = shipping
        ? price + ' · FREE SHIPPING'
        : price;
      btnAdd.classList.remove('hidden');
    }

    // Trust row
    const footer = modal.querySelector('.bundle-modal-footer');
    if (footer && !footer.querySelector('.bundle-trust-row')) {
      const trustRow = document.createElement('div');
      trustRow.className = 'bundle-trust-row';
      trustRow.innerHTML = [
        'Secure payment',
        '30-day returns',
        'AU support'
      ].map(t => `<div class="bundle-trust-item"><div class="bundle-trust-dot"></div>${t}</div>`).join('');
      footer.appendChild(trustRow);
    }
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.add('hidden');
    document.body.style.overflow = '';
    document.body.classList.remove('bundle-open');
  }

  function buildDOM() {
    stepsWrapper.innerHTML = '';
    selectedVariants = [];

    const availableVariants = variants.filter(v => v.available);
    if (!availableVariants.length) return;

    const useGrid = totalSteps === 2;

    const imageGrid = document.createElement('div');
    imageGrid.className = useGrid ? 'bundle-pair-grid' : 'bundle-pair-list';

    const selectorsSection = document.createElement('div');
    selectorsSection.className = 'bundle-selectors-section';

    for (let i = 0; i < totalSteps; i++) {
      const defaultVariant = availableVariants[i < availableVariants.length ? i : 0];
      selectedVariants[i] = defaultVariant.id;

      const card = document.createElement('div');
      card.className = 'bundle-pair-card';

      const pairLabel = document.createElement('div');
      pairLabel.className = 'bundle-pair-label';
      pairLabel.textContent = 'Pair ' + (i + 1);

      const imgWrap = document.createElement('div');
      imgWrap.className = 'bundle-pair-img-wrap';
      const img = document.createElement('img');
      img.id = 'bundle-image-' + (i + 1);
      img.className = 'bundle-pair-img';
      img.alt = 'Pair ' + (i + 1);
      const defaultSrc = defaultVariant.featured_image
        ? defaultVariant.featured_image.src
        : (defaultVariant.image ? defaultVariant.image.src : null);
      if (defaultSrc) img.src = defaultSrc;
      imgWrap.appendChild(img);

      card.appendChild(pairLabel);
      card.appendChild(imgWrap);
      imageGrid.appendChild(card);

      const selectorRow = document.createElement('div');
      selectorRow.className = 'bundle-selector-row';

      const topRow = document.createElement('div');
      topRow.className = 'bundle-selector-top';

      const labelEl = document.createElement('span');
      labelEl.className = 'bundle-selector-pair-label';
      labelEl.textContent = 'Pair ' + (i + 1);

      const colorName = document.createElement('span');
      colorName.className = 'bundle-selector-color-name';
      colorName.textContent = defaultVariant.title.split(' / ')[0];

      topRow.appendChild(labelEl);
      topRow.appendChild(colorName);

      const chipsRow = document.createElement('div');
      chipsRow.className = 'bundle-pair-chips';

      availableVariants.forEach(variant => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'bundle-chip' + (variant.id === defaultVariant.id ? ' selected' : '');
        chip.dataset.variantId = variant.id;
        chip.dataset.colorName = variant.title.split(' / ')[0];
        chip.title = variant.title.split(' / ')[0];

        const imgSrc = variant.featured_image
          ? variant.featured_image.src
          : (variant.image ? variant.image.src : null);
        if (imgSrc) {
          chip.style.backgroundImage = 'url(' + imgSrc + ')';
          chip.style.backgroundSize = 'contain';
          chip.style.backgroundPosition = 'center';
          chip.style.backgroundRepeat = 'no-repeat';
        }

        chip.addEventListener('click', function() {
          selectedVariants[i] = variant.id;
          chipsRow.querySelectorAll('.bundle-chip').forEach(function(c) {
            c.classList.remove('selected');
          });
          chip.classList.add('selected');
          colorName.textContent = chip.dataset.colorName;
          const newSrc = variant.featured_image
            ? variant.featured_image.src
            : (variant.image ? variant.image.src : null);
          if (newSrc) img.src = newSrc;
          syncThumb();
        });

        chipsRow.appendChild(chip);
      });

      const scrollTrack = document.createElement('div');
      scrollTrack.className = 'bundle-scroll-track';
      const scrollThumb = document.createElement('div');
      scrollThumb.className = 'bundle-scroll-thumb';
      scrollTrack.appendChild(scrollThumb);

      selectorRow.appendChild(topRow);
      selectorRow.appendChild(chipsRow);
      selectorRow.appendChild(scrollTrack);
      selectorsSection.appendChild(selectorRow);

      function syncThumb() {
        const scrollable = chipsRow.scrollWidth - chipsRow.clientWidth;
        if (scrollable <= 0) {
          scrollTrack.style.display = 'none';
          return;
        }
        scrollTrack.style.display = 'block';
        const ratio = chipsRow.clientWidth / chipsRow.scrollWidth;
        const thumbW = Math.max(24, ratio * scrollTrack.clientWidth);
        const maxLeft = scrollTrack.clientWidth - thumbW;
        const progress = chipsRow.scrollLeft / scrollable;
        scrollThumb.style.width = thumbW + 'px';
        scrollThumb.style.left = (progress * maxLeft) + 'px';
      }

      chipsRow.addEventListener('scroll', syncThumb);

      var isDragging = false;
      var dragStartX = 0;
      var dragStartScroll = 0;

      scrollThumb.addEventListener('mousedown', function(e) {
        isDragging = true;
        dragStartX = e.clientX;
        dragStartScroll = chipsRow.scrollLeft;
        e.preventDefault();
      });

      document.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        var dx = e.clientX - dragStartX;
        var scrollable = chipsRow.scrollWidth - chipsRow.clientWidth;
        var trackMovable = scrollTrack.clientWidth - scrollThumb.clientWidth;
        if (trackMovable <= 0) return;
        chipsRow.scrollLeft = dragStartScroll + (dx / trackMovable) * scrollable;
      });

      document.addEventListener('mouseup', function() {
        isDragging = false;
      });

      requestAnimationFrame(syncThumb);
    }

    stepsWrapper.appendChild(imageGrid);
    stepsWrapper.appendChild(selectorsSection);
  }

  function handleAddToCart() {
    if (errorMessage) errorMessage.classList.add('hidden');
    btnAdd.textContent = 'Adding...';
    btnAdd.disabled = true;

    const combinedItems = {};
    selectedVariants.forEach(id => {
      combinedItems[id] = (combinedItems[id] || 0) + 1;
    });

    const items = Object.entries(combinedItems).map(([id, qty]) => ({
      id: parseInt(id, 10),
      quantity: qty
    }));

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then(r => r.json())
      .then(data => {
        if (data.status === 422) throw new Error(data.description);
        window.location.href = '/cart';
      })
      .catch(error => {
        if (errorMessage) {
          errorMessage.textContent = 'Error: ' + error.message;
          errorMessage.classList.remove('hidden');
        }
        btnAdd.textContent = totalSteps + ' PAIRS — ' + (window._bundlePrice || '');
        btnAdd.disabled = false;
      });
  }

  init();
});
